import { createFileRoute } from '@tanstack/react-router'

import { WebhookEditorPage } from '@/features/integrations/webhook-editor'

export const Route = createFileRoute('/_app/integracoes/webhooks/novo')({
  component: () => <WebhookEditorPage />,
})
